import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { ISiteRepository } from '@/api/fe-api/domain/repositories/site.repository';

export namespace GetSiteLevels {
  export const key = (input: Input): string[] => [
    'customer-info',
    'get-site-levels',
    ...Object.entries(input).flatMap(([key, value]) => [key, String(value)]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = ISiteRepository.GetLevelsInput;
  export type Output = ISiteRepository.GetLevelsOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.site.getLevels(input),
    });
  }
}
